import { Box, Card, Typography, Button, Chip, Stack, List, Avatar, Grid, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { LocationOn, Fullscreen, SystemUpdateAlt, BugReport, Sync, PowerSettingsNew } from '@mui/icons-material';


function RemoteAccess() {

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 1024);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [isMobile]);

    const actionData = [
        {
            title: "Restart Device",
            desc: "Perform a soft restart",
            icon: <PowerSettingsNew color="primary" />,
        },
        {
            title: "Sync Configuration",
            desc: "Update device settings",
            icon: <Sync color="success" />,
        },
        {
            title: "Run Diagnostics",
            desc: "Execute health check",
            icon: <BugReport color="secondary" />,
        },
        {
            title: "Force Update",
            desc: "Push firmware update",
            icon: <SystemUpdateAlt color="warning" />,
        },
    ];

    const ActionItem = ({ icon, title, desc, last }) => (
        <ListItem
            sx={{
                border: "1px solid #e5e7eb",
                borderRadius: 3,
                mb: last ? 0 : 2,
            }}
        >
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText
                primary={title}
                secondary={desc}
                primaryTypographyProps={{ fontWeight: 600 }}
            />
        </ListItem>
    );


    return (
        <>
            <Grid container spacing={2} mt={4}>

                {/* REMOTE ACTIONS */}
                <Grid item xs={12} md={4}>
                    <Card sx={{ p: isMobile ? 3 : 2, borderRadius: 4, height: "380px", width: isMobile ? "100%" : "250px" }}>
                        <Stack direction="row" justifyContent="space-between" mb={2}>
                            <Typography fontWeight={600}>Remote Actions</Typography>
                        </Stack>

                        <List>
                            {actionData.map((item, index) => (
                                <ActionItem
                                    key={index}
                                    {...item}
                                    last={index === actionData.length - 1}
                                />
                            ))}
                        </List>
                    </Card>
                </Grid>

                {/* DEVICE LOCATION */}
                <Grid item xs={12} md={4}>
                    <Card sx={{ p: isMobile ? 3 : 2, borderRadius: 4, height: "380px", width: isMobile ? "100%" : "250px" }}>
                        <Stack direction="row" justifyContent="space-between" mb={2}>
                            <Typography fontWeight={600}>Device Location</Typography>
                            <Button size="small"><Fullscreen /></Button>
                        </Stack>

                        <Box
                            sx={{
                                bgcolor: "#f3f4f6",
                                p: 3,
                                borderRadius: 4,
                                textAlign: "center",
                            }}
                        >
                            <Chip label="Signal: -67 dBm" />

                            <Avatar
                                sx={{
                                    bgcolor: "#e0ecff",
                                    color: "#2563eb",
                                    width: 56,
                                    height: 56,
                                    mx: "auto",
                                    my: 2,
                                }}
                            >
                                <LocationOn />
                            </Avatar>

                            <Typography fontWeight={600}>
                                Building A - Floor 3
                            </Typography>
                            <Typography fontSize={14} color="text.secondary">
                                Room 315, North Wing
                            </Typography>
                            <Typography fontSize={13} color="text.secondary" mt={1}>
                                Lat: 40.7128, Lng: -74.0060
                            </Typography>

                            <Chip label="Online" color="success" sx={{ mt: 2 }} />
                        </Box>
                    </Card>
                </Grid>
            </Grid>
        </>
    )
}

export default RemoteAccess